import { render, staticRenderFns } from "./ModalDuplicProduct.vue?vue&type=template&id=757f064b&scoped=true"
import script from "./ModalDuplicProduct.vue?vue&type=script&lang=js"
export * from "./ModalDuplicProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalDuplicProduct.vue?vue&type=style&index=0&id=757f064b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757f064b",
  null
  
)

export default component.exports